import { z } from "zod";

import { rawNullableStringSchema } from "./rawNullableStringSchema";
import { rawNumberSchema } from "./rawNumberSchema";
import { rawStringSchema } from "./rawStringSchema";

export const parishSearchItemSchema = z.object({
  city: rawStringSchema,
  street_address: rawStringSchema,
  region: rawStringSchema,
  postal_code: rawStringSchema,
  /** Full display address; street_address/postal_code are often empty in the index. */
  formatted_address: rawNullableStringSchema.optional(),
  name: rawStringSchema,
  id: rawNumberSchema,
});

export type ParishSearchItem = z.infer<typeof parishSearchItemSchema>;
